import { REQUEST_FREEWRITE_EXPORT } from './ActionTypes';

const requestFreeWriteExport = () => (
  (dispatch) => {
    dispatch({
      type: REQUEST_FREEWRITE_EXPORT,
    });
  }
);

export default requestFreeWriteExport;



// WEBPACK FOOTER //
// ./src-react/EditorOverlay/EditorOverlayActions/requestFreeWriteExport.jsx